import { motion } from 'framer-motion';
import { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import SummaryApi from '../common';
import { request } from '../helpers/request';

const ResetPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();
    const query = new URLSearchParams(location.search);
    const token = query.get('token');

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            return toast.error("Passwords do not match.");
        }

        setLoading(true);

        try {
            const response = await request(SummaryApi.resetPassword, {
                body: JSON.stringify({ token, password, confirmPassword })
            });

            const data = await response.json();

            if (data.success) {
                toast.success(data.message);
                navigate('/login');
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            toast.error("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    if (!token) {
        return (
            <div className='min-h-screen flex items-center justify-center p-6'>
                <p className='text-red-500 font-bold'>Invalid or missing reset token.</p>
            </div>
        );
    }

    return (
        <section className='min-h-screen flex items-center justify-center bg-surface-muted py-20 px-6'>
            <motion.div 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className='w-full max-w-md bg-white rounded-card shadow-premium p-10'
            >
                <div className='text-center mb-8'>
                    <h1 className='text-3xl font-black text-primary tracking-tight'>New Password</h1>
                    <p className='text-gray-500 font-medium mt-1'>Please enter your new secure password.</p>
                </div>

                <form className='space-y-6' onSubmit={handleSubmit}>
                    {}
                    <div className='space-y-1.5'>
                        <label className='text-[10px] font-black uppercase tracking-widest text-gray-400 ml-1'>New Password</label>
                        <div className='h-12 bg-surface-muted rounded-2xl border border-surface-border px-4 flex items-center focus-within:border-accent transition-all'>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                placeholder='••••••••'
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className='w-full h-full outline-none bg-transparent font-bold text-primary placeholder:text-gray-300 text-sm'
                            />
                            <div className='cursor-pointer text-gray-400 ml-2' onClick={() => setShowPassword(!showPassword)}>
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </div>
                        </div>
                    </div>

                    {}
                    <div className='space-y-1.5'>
                        <label className='text-[10px] font-black uppercase tracking-widest text-gray-400 ml-1'>Confirm Password</label>
                        <div className='h-12 bg-surface-muted rounded-2xl border border-surface-border px-4 flex items-center focus-within:border-accent transition-all'>
                            <input
                                type={showConfirmPassword ? 'text' : 'password'}
                                placeholder='••••••••'
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                                className='w-full h-full outline-none bg-transparent font-bold text-primary placeholder:text-gray-300 text-sm'
                            />
                            <div className='cursor-pointer text-gray-400 ml-2' onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                            </div>
                        </div>
                    </div>

                    <button 
                        disabled={loading}
                        className='w-full h-14 bg-primary text-white font-black text-lg rounded-full hover:bg-accent transition-all shadow-xl shadow-primary/20 active:scale-95 disabled:opacity-50'
                    >
                        {loading ? "Resetting..." : "Update Password"}
                    </button>
                </form>
            </motion.div>
        </section>
    );
};

export default ResetPassword;
